import { c as o } from "../../../../index.esm-BeDSGXP5.js";
import { css as a } from "styled-components";
const e = {
  base: () => /* @__PURE__ */ a([
    "border-radius:4rem;",
    ""
  ], o({
    padding: [
      "lg",
      null,
      "xl"
    ],
    boxShadow: [
      "0.5rem 0.5rem 0.7rem rgba(0, 0, 0, 0.25)",
      null,
      "1rem 1.4rem 1.4rem rgba(0, 0, 0, 0.25)"
    ]
  })),
  light: ({ theme: r }) => /* @__PURE__ */ a([
    "",
    ""
  ], o({
    backgroundColor: r.componentColors.card.backgroundLight
  })),
  dark: ({ theme: r }) => /* @__PURE__ */ a([
    "",
    ""
  ], o({
    backgroundColor: r.componentColors.card.backgroundDark
  }))
};
export {
  e as default
};
